import type { DimensionType, SizeConfig } from '../themes/types';
import { getLoggerSafe } from '@vitvio/logging';

// Generic function to get dimension tokens from a theme's size configuration
export function getDimensionToken<T extends string>(
  dimensionType: DimensionType,
  token: T,
  sizeConfig: SizeConfig,
  withUnit?: true,
): string;
export function getDimensionToken<T extends string>(
  dimensionType: DimensionType,
  token: T,
  sizeConfig: SizeConfig,
  withUnit: false,
): number;
export function getDimensionToken<T extends string>(
  dimensionType: DimensionType,
  token: T,
  sizeConfig: SizeConfig,
  withUnit?: boolean,
): string | number {
  // Get the appropriate values based on dimension type
  const values = sizeConfig[dimensionType] as Record<T, number>;
  const rawValue = values[token];

  if (rawValue === undefined) {
    getLoggerSafe()?.warn(`[design-system] Unknown ${dimensionType} token: "${token}"`);
  }

  const dimensionValue = rawValue ?? 0;

  if (withUnit === false) return dimensionValue;
  if (dimensionValue === 0) return '0';
  return `${dimensionValue}px`;
}
